import { CSSProperties, useMemo } from 'react';

type LogoProps = {
  type: 'white' | 'primary' | 'icon';
  style?: CSSProperties;
};

const Logo = ({ type, style = undefined }: LogoProps) => {
  const src = useMemo(
    () =>
      ({
        white: 'images/vydura-logo-white.svg',
        primary: 'images/vydura-logo.svg',
        icon: 'images/vydura-icon.svg',
      })[type],
    [type]
  );

  return <img src={src} style={style} alt='vydura logo' />;
};

export default Logo;
